import React from 'react';
import PropTypes from 'prop-types';

import { markerIcon } from 'utils';

import ProjectCard from 'components/ProjectCard';

class ProjectMarkers extends React.PureComponent {
    static propTypes = {
        clickedProject: PropTypes.number,
        onMarkerClick: PropTypes.func,
        projects: PropTypes.arrayOf(PropTypes.shape({
            location: PropTypes.string,
        })).isRequired,
        projectStatusLabel: PropTypes.string.isRequired,
        filterSearch: PropTypes.func.isRequired,
        options: PropTypes.object,
        maxClusterRadius: PropTypes.number,
    }
    static defaultProps = {
        options: {},
        maxClusterRadius: 80,
    }

    state = {
        render: false,
    }

    componentDidMount() {
        this.MarkerClusterGroup = require('react-leaflet-markercluster').default;
        this.Marker = require('react-leaflet').Marker;
        this.Popup = require('react-leaflet').Popup;

        const projectList = document.getElementById('project-list');

        if(projectList) {
            projectList.addEventListener('project', this._handleProjectEvent);
        }

        this.setState({
            render: true,
        });
    }

    _handleProjectEvent = e => {
        if(! this.cluster || !this.cluster.getLayers) return;

        const markers = this.cluster.getLayers();
        const marker = markers.find(m => m.options.project == e.detail);

        if(marker) {
            this.cluster.zoomToShowLayer(marker, () => {
                if(! marker.isPopupOpen()) {
                    marker.fire('click');
                }
            });
        } else {
            console.error('Failed to find project marker with id', e.detail);
        }
    }

    render() {
        const {
            projects,
            projectStatusLabel,
            filterSearch,
            options,
            maxClusterRadius,
        } = this.props;

        const {
            render
        } = this.state;

        if(! render) return null;

        const MarkerClusterGroup = this.MarkerClusterGroup;
        const Marker = this.Marker;
        const Popup = this.Popup;

        return (
            <MarkerClusterGroup
                options={{
                    maxClusterRadius,
                    iconCreateFunction: this._clusterIcon,
                    showCoverageOnHover: false,
                    ...options
                }}
                ref={node => this.cluster = node && node.leafletElement}
            >
                {projects && projects.filter(p => p.location).filter(filterSearch).map(p => (
                    <Marker
                        key={p.id}
                        icon={markerIcon(p)}
                        position={p.location.split(",").map(parseFloat)}
                        project={p.id}
                    >
                        <Popup>
                            <ProjectCard
                                {...p}
                                address={null}
                                compact
                                view="grid"
                                displayText={false}
                                projectStatusLabel={projectStatusLabel}
                            />
                        </Popup>
                    </Marker>
                ))}
            </MarkerClusterGroup>
        );
    }
}

export default ProjectMarkers;



// WEBPACK FOOTER //
// ./src/components/ProjectMarkers/ProjectMarkers.jsx